"use client";
import { jsx as m } from "react/jsx-runtime";
import { memo as g, useState as d, useEffect as B } from "react";
import * as u from "@radix-ui/react-avatar";
import { ikp as t } from "./factory.js";
import f from "../atoms/avatars/ai.js";
import { useInkeepConfig as _ } from "../providers/config-provider.js";
import { composeEventHandlers as p } from "../utils/compose-event-handlers.js";
import { useColorModeValue as A } from "@inkeep/cxkit-color-mode";
const b = t("div", {
  _id: "chatButton__Container"
}), E = t("button", {
  _id: "chatButton__Button"
}), U = t("div", {
  _id: "chatButton__Text"
}), j = t(u.Root, {
  _id: "chatButton__AvatarContent"
}), l = t(u.Image, {
  _id: "chatButton__AvatarImage"
}), H = g((r) => {
  const { onLoadingStatusChange: c, avatar: a, ...h } = r, { aiChatSettings: v } = _(), { aiAssistantAvatar: o } = v ?? {}, n = typeof a == "string" ? a : A(a?.light, a?.dark), i = typeof o == "string" ? o : o?.dark, [e, s] = d(
    n ?? i
  );
  return B(() => {
    s(n ?? i);
  }, [n, i]), e ? /* @__PURE__ */ m(
    l,
    {
      src: e,
      "data-type": "image",
      onLoadingStatusChange: p(c, (C) => {
        C === "error" && s(null);
      }),
      ...h
    }
  ) : /* @__PURE__ */ m(f, { "data-type": "icon", ...r });
});
export {
  E as ChatButton,
  j as ChatButtonAvatarContent,
  H as ChatButtonAvatarImage,
  b as ChatButtonContainer,
  H as ChatButtonPrimitiveAvatarImage,
  U as ChatButtonText
};
